export default __webpack_public_path__ + "fdddd58a68b6e3dc46012a4febf2b440.png";